import Grid from "@mui/material/Grid";
import { type PropsWithChildren } from "react";
import { FormDisplayWidth } from "@/components/site-builder/modules/CustomFormModule/constants";
import { useCustomFormContext } from "@/components/site-builder/modules/CustomFormModule/context/customFormContext";

export default function CustomFormContainer(props: PropsWithChildren) {
  const { children } = props;

  const {
    formBody: { displayWidth },
  } = useCustomFormContext();

  switch (displayWidth) {
    case FormDisplayWidth.HalfWidthLeftAligned:
      return (
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }}>{children}</Grid>
        </Grid>
      );

    case FormDisplayWidth.HalfWidthRightAligned:
      return (
        <Grid container>
          <Grid size={{ xs: 12, md: 6 }} offset={{ md: 6 }}>
            {children}
          </Grid>
        </Grid>
      );

    default:
      return (
        <Grid container>
          <Grid size={{ xs: 12 }}>{children}</Grid>
        </Grid>
      );
  }
}
